import { Fragment } from "react"
import { LanguageISO } from "@providers"
import { serverPath } from "@lib/server"

interface CommonMetaProps {
  lang?: LanguageISO
  siteName: string
}

export function CommonMeta(props: CommonMetaProps) {
  const { lang, siteName } = props

  return (
    <Fragment>
      <meta charSet="utf-8" />
      <meta httpEquiv="X-UA-Compatible" content="IE=edge, chrome=1" />
      <meta name="robots" content="index,follow" />
      <meta name="googlebot" content="index,follow" />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={lang} />

      <link rel="manifest" href={serverPath("/site.webmanifest")} />
      <meta name="theme-color" content="#000000" />
      <link
        rel="icon"
        type="image/png"
        sizes="16x16"
        href={serverPath("/static/images/favicons/favicon-16x16.png")}
      />
      <link
        rel="icon"
        type="image/png"
        sizes="32x32"
        href={serverPath("/static/images/favicons/favicon-32x32.png")}
      />

      <AppleMeta />
      <GoogleMeta />
    </Fragment>
  )
}

export function AppleMeta() {
  return (
    <Fragment>
      <link
        rel="apple-touch-icon"
        sizes="180x180"
        href={serverPath("/static/images/favicons/apple-touch-icon.png")}
      />
    </Fragment>
  )
}

export function GoogleMeta() {
  return (
    <Fragment>
      <meta
        name="google-site-verification"
        content="-Im4tZbLkP3ygSjWfX_pQnCYWwWylkSDPXtQdmhCSNY"
      />

      <link
        rel="icon"
        type="image/png"
        sizes="192x192"
        href={serverPath("/static/images/favicons/android-chrome-192x192.png")}
      />

      <link
        rel="icon"
        type="image/png"
        sizes="512x512"
        href={serverPath("/static/images/favicons/android-chrome-512x512.png")}
      />
    </Fragment>
  )
}
